import { Alert } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Collapsible, { CollapseEventListener } from '@philips-emr/tws-core/lib/component/types/collapsible';

export interface InformationBarAllergiesList {
  title?: string;
  allergies: InformationBarAllergy[];
}

export interface InformationBarAllergy {
  severity: string;
  description: string;
}

export interface InformationBarField {
  label: string;
  value?: string;
  visible?: boolean;
}

class InformationBarAPI extends ComponentAPI implements Collapsible {

  /** @event */
  @AwesomeEvent
  onCollapse = new CollapseEventListener();

  isCollapsed(): boolean {
    return this.state.colapsed;
  }

  setCollapsed(colapsed: boolean): void {
    this.setState({ colapsed });
  }

  getAlerts(): Record<Alert, string> {
    return this.state.alerts;
  }

  setAlerts(alerts: Record<Alert, string>): void {
    this.setState({ alerts });
  }

  getAlertsTitle(): string {
    return this.state.alertsTitle;
  }

  setAlertsTitle(alertsTitle: string): void {
    this.setState({ alertsTitle });
  }

  getAllergies(): InformationBarAllergiesList {
    return this.state.allergies;
  }

  setAllergies(allergies: InformationBarAllergiesList): void {
    this.setState({ allergies });
  }

  getExtraInformation(): Record<string, InformationBarField> {
    return this.state.extraInformation;
  }

  setExtraInformation(extraInformation: Record<string, InformationBarField>): void {
    this.setState({ extraInformation });
  }

  getExtraInformationTitle(): string {
    return this.state.extraInformationTitle;
  }

  setExtraInformationTitle(extraInformationTitle: string): void {
    this.setState({ extraInformationTitle });
  }

  getFieldOneTitle(): string {
    return this.state.fieldOneTitle;
  }

  setFieldOneTitle(fieldOneTitle: string): void {
    this.setState({ fieldOneTitle });
  }

  getFieldOneValue(): string {
    return this.state.fieldOneValue;
  }

  setFieldOneValue(fieldOneValue: string): void {
    this.setState({ fieldOneValue });
  }

  getFieldTwoTitle(): string {
    return this.state.fieldTwoTitle;
  }

  setFieldTwoTitle(fieldTwoTitle: string): void {
    this.setState({ fieldTwoTitle });
  }

  getFieldTwoValue(): string {
    return this.state.fieldTwoValue;
  }

  setFieldTwoValue(fieldTwoValue: string): void {
    this.setState({ fieldTwoValue });
  }

  getImage(): string {
    return this.state.image;
  }

  setImage(image: string): void {
    this.setState({ image });
  }

  getTitle(): string {
    return this.state.title;
  }

  setTitle(title: string): void {
    this.setState({ title });
  }
}

export default InformationBarAPI;
